import { render, staticRenderFns } from "./OdisCallback.vue?vue&type=template&id=c04933ba&"
import script from "./OdisCallback.vue?vue&type=script&lang=js&"
export * from "./OdisCallback.vue?vue&type=script&lang=js&"
import style0 from "./OdisCallback.vue?vue&type=style&index=0&id=c04933ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports